import type { EnrollmentByProductDto, GetEnrollmentsByProductParams, PaginatedResponseDto } from "@repo/types";
import { useQuery } from "@tanstack/react-query";
import { getProductEnrollments } from "../api/productApi";

/**
 * 상품별 수강 목록 조회 hook
 *
 * @param productId - 상품 ID
 * @param page - 페이지 번호
 * @param limit - 페이지당 항목 수
 * @returns React Query 결과
 */
export const useProductEnrollments = (
  productId: number,
  params: GetEnrollmentsByProductParams
) => {
  return useQuery<PaginatedResponseDto<EnrollmentByProductDto>>({
    queryKey: ["product", productId, "enrollments", params],
    queryFn: () => getProductEnrollments(productId, params),
    enabled: !!productId,
  });
};
